import React, { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Routes } from '@/routes/router';
import ClipLoader from 'react-spinners/ClipLoader';
import { getPostLoginRedirect } from '@/utils/postLoginRedirect';

const LoadingSpinner = () => (
    <div className="flex items-center justify-center h-screen">
        <ClipLoader color="#4A90E2" size={50} />
    </div>
);

const PublicRoute: React.FC = () => {
    const { user, initializing } = useAuth();

    if (initializing) {
        return <LoadingSpinner />;
    }

    return user ? (
        <Navigate to={getPostLoginRedirect() ?? Routes.PORTAL} replace />
    ) : (
        <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
        </Suspense>
    );
};

export default PublicRoute;
